exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goal-bg{\n    background-color:#e6e6e6 ;\n    margin:7px;\n}\n\n.add-goal{\n    margin-right: 25px\n}\n.clone-template-dropdown {\n  width: 60%;\n}\n.clone-template, .create-account-metrics-head {\n  margin-top: 6px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/accountMetrics/create-account-metrics/create-account-metrics.component.css
// module id = ../../../../../src/app/accountMetrics/create-account-metrics/create-account-metrics.component.css
// module chunks = main